var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionGroup',_vm._g(_vm._b({attrs:{"name":"fade-up","appear":"","tag":_vm.tag}},'TransitionGroup',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }